import React from "react";

const DetailModal = ({
  show,
  title = "Details",
  data = {},
  loading = false,
  onClose,
  size = "modal-lg"
}) => {

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1">
        <div className={`modal-dialog ${size} modal-dialog-scrollable`}>
          <div className="modal-content shadow border-0 rounded-3">

            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title fw-semibold">
                {title}
              </h5>

              <button
                className="btn-close"
                onClick={onClose}
              />
            </div>


            {/* Body */}
            <div className="modal-body">
              {loading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" />
                  <p className="mt-2">
                    Loading...
                  </p>
                </div>

              ) : !data || Object.keys(data).length === 0 ? (
                <div className="text-center text-muted">
                  No data found
                </div>

              ) : (

                <div className="table-responsive">
                  <table className="table table-bordered table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "35%" }}>
                          Field
                        </th>

                        <th>
                          Value
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {Object.entries(data).map(([key, value]) => (
                        <tr key={key}>
                          <td className="fw-semibold">
                            {key}
                          </td>
                          <td className="text-break wrap-text">
                            {value ?? "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};


export default DetailModal;